import { render, staticRenderFns } from "./officialWebStoreApp.vue?vue&type=template&id=c1a3bf10&"
import script from "./officialWebStoreApp.vue?vue&type=script&lang=js&"
export * from "./officialWebStoreApp.vue?vue&type=script&lang=js&"
import style0 from "./officialWebStoreApp.vue?vue&type=style&index=0&id=c1a3bf10&prod&lang=css&"
import style1 from "./officialWebStoreApp.vue?vue&type=style&index=1&id=c1a3bf10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports